import { io } from "socket.io-client";
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

export const socket = io(apiBaseUrl, { autoConnect: false });
